

























































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Workspace, Summary, ParentChildWorkflowInfo } from "@/entities";

@Component
export default class ParentChildProgressBar extends Vue {

  @Prop() workflowInfo: ParentChildWorkflowInfo;
  @Prop() hideParent: boolean;

  /** workflow completion status */
  stepStatus: any = {
      notStarted: 1,
      inProgress: 2,
      completed: 3
  }; 

  /** transforming journey array based on current status */
  get mergedJourney() {

    var journey = [];
    var completedSteps = [];

    if(this.workflowInfo.LogStatus) {
        completedSteps = this.workflowInfo.LogStatus.map(x => x.StepId);
    }

    this.workflowInfo.Journey.forEach((item) => {
        
       const log = this.workflowInfo.LogStatus.find(x => x.StepId == item.StepId);
        if(item.WorkflowData && item.WorkflowData.ChildSteps.length > 0) {
            const childStepsCompleted = item.WorkflowData.ChildSteps.filter(x => x.IsCompleted != 1).length === 0;
            
            if(!this.hideParent) {
                if(log && childStepsCompleted) {
                    journey.push(Object.assign({ "completionStatus": this.stepStatus.completed }, log, item))                
                } else if (log) {
                    journey.push(Object.assign({ "completionStatus": this.stepStatus.inProgress }, log, item))                
                } else {
                    journey.push(Object.assign({ "completionStatus": this.stepStatus.notStarted }, item))                
                }
            }

            item.WorkflowData.ChildSteps.forEach((childStep) => {
                const childStatus = item.ChildSteps.find(x => x.StepId == childStep.StepStatusId);
                const childLog = log.ChildWorkflowHistory.slice().reverse().find(x => x.ChildStepId == childStep.StepId)
                
                const Status = childStep.Description
                if(childStep.IsCompleted) {
                    journey.push(Object.assign({}, childLog || {}, { "completionStatus": this.stepStatus.completed, "isChild": true, Status }))                
                } else if(childStep.StepStatusId) {
                    journey.push(Object.assign({}, childLog || {}, { "completionStatus": this.stepStatus.inProgress, "isChild": true, Status }))                
                } else {
                    journey.push(Object.assign({}, childLog || {}, { "completionStatus": this.stepStatus.notStarted, "isChild": true, Status }))                
                }
            })
            
        } else {
            if(!this.hideParent) {
                if (log) {
                    journey.push(Object.assign({ 
                        "completionStatus": this.workflowInfo.CurrentStep.WorkFlowStepId == item.StepId ? this.stepStatus.inProgress : this.stepStatus.completed 
                        }, log, item))                
                } else {
                    journey.push(Object.assign({ "completionStatus": this.stepStatus.notStarted }, item))                
                }
            }
        }
    })
    return journey;
  }
}

